import { Trans, useTranslation } from 'react-i18next';

import { Alert, ExternalLink, Link, Redirect, Text } from '~/components';
import { Field, Input } from '~/components/Form';
import { routes } from '~/providers/RouterProvider/router.routes';

import { AuthLayoutContent } from '../AuthLayout/AuthLayoutContent';
import { AuthLayoutTitleGroup } from '../AuthLayout/AuthLayoutTitleGroup';
import { AuthLink } from '../AuthLink/AuthLink';
import { useRegistrationContext } from './Registration.context';
import { contentWrapperStyle, messageStyle } from './RegistrationCompany.css';

export const RegistrationCompany = () => {
  const { vatInformation } = useRegistrationContext();

  const { t } = useTranslation(['auth']);

  if (!vatInformation || vatInformation.enterpriseType === 0) return <Redirect to={routes.register} />;

  return (
    <AuthLayoutContent>
      <AuthLayoutTitleGroup
        eyebrow={t('auth:registrationPage.common.header.pill')}
        subtitle={t('auth:registrationPage.stepCompany.header.subtitle')}
        title={t('auth:registrationPage.stepCompany.header.title', { name: vatInformation.companyName })}
      />

      <div className={contentWrapperStyle}>
        <Field.Root>
          <Field.Label>{t('auth:registrationPage.stepVatNumber.form.vatNumberField.label')}</Field.Label>

          <Input disabled prefix="BE" value={vatInformation.vatNumber.slice(2)} />

          <Text className={messageStyle}>
            {t('auth:registrationPage.stepCompany.changeVatNumber.message')}{' '}
            <Link to={routes.register}>{t('auth:registrationPage.stepCompany.changeVatNumber.action')}</Link>
          </Text>
        </Field.Root>

        <Alert announce={false} icon="Info" status="info" title={t('auth:registrationPage.stepCompany.alert.title')}>
          <p>
            <Trans
              components={{ break: <br />, kiiaLink: <ExternalLink /> }}
              i18nKey="auth:registrationPage.stepCompany.alert.description"
            />
          </p>
        </Alert>
      </div>

      <AuthLink to="login" />
    </AuthLayoutContent>
  );
};
